<header mat-dialog-title>{{ context?.title }}</header>
<div mat-dialog-content class="dialog-info">
  <p>{{ context.content }}</p>
  <p class="d-flex">
    <loader [isVisible]="true" [isInline]="true" size="24px"class="mr-05"></loader>
    {{ context.fileName }}
  </p>
</div>
